<template>
  <div>
    <div class="row" v-for="(name,idx) in dataArr" :key="idx">
      <div class="col-1">
        <label for="name">{{ idx }}</label>
      </div>
      <div class="col-7">
        <div class="form-group">
          <input class="form-control discountLbl" :id="'name-' + idx" v-model="dataArr[idx]" @keyup="debouncedUpdateF(idx)"/>
        </div>
      </div>
      <div class="col-4">
        <button class="btn btn-danger" @click="deleteF(idx)">
          <span class="spinner-border spinner-border-sm spinDel d-none" :id="'spinnerF_'+idx" role="status" aria-hidden="true"></span>
          Delete
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-primary" @click="addF">
          <span class="spinner-border spinner-border-sm spinAdd d-none" id="spinnerAddF" role="status" aria-hidden="true"></span>
          Add
          </button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "Finish",
  data() {
    return {
      dataArr: [],
      debounceTimeouts: {}
    };
  },
  emits: {
    updateFinish: null
  },
  computed: {
    ...mapGetters({
      'finishData': 'product/getFinishData',
    }),

  },
  methods: {
    debouncedUpdateF(idx) {
      if (this.debounceTimeouts[idx]) {
        clearTimeout(this.debounceTimeouts[idx]);
      }
      this.debounceTimeouts[idx] = setTimeout(() => {
        this.updateF(idx);
      }, 800); // 500ms delay
    },
    addF() {
      document.querySelector('#spinnerAddF').classList.remove('d-none');
      this.$store.dispatch('product/setupFinish',{data: {name:'*******'}, method:'post'}).then(rez => {
        this.dataArr[rez.id] = rez.name
        this.$emit('updateFinsih', this.dataArr)
        document.querySelector('#spinnerAddF').classList.add('d-none');
      })
    },
    deleteF(id) {
      document.querySelector('#spinnerF_'+id).classList.remove('d-none');
      this.$store.dispatch('product/setupFinish',{data: {id}, method:'delete'}).then(rez => {
        if(rez.success) {
          delete this.dataArr[id]
          this.$emit('updateFinish', this.dataArr)
        }
        document.querySelector('#spinnerF_'+id).classList.add('d-none');
      })
    },
    updateF(id) {
      document.querySelector('#spinnerF_'+id).classList.remove('d-none');
      this.$store.dispatch('product/setupFinish',{data: {id, name: this.dataArr[id]}, method:'put'}).then(rez => {
        if(rez.success) {
          this.dataArr[rez.id] = rez.name
          this.$emit('updateFinish', this.dataArr)
        }
        document.querySelector('#spinnerF_'+id).classList.add('d-none');
      })
    },
  },
  mounted() {
    this.dataArr = this.finishData
    this.$store.dispatch('product/setupFinish',{method:'get'}).then(() => {
      this.dataArr = this.finishData
      this.$emit('updateFinish', this.dataArr)
    })
  }
};
</script>
<style scoped>

.spinDel{
  position: absolute;
  left:35px;
  top:10px;
}

.spinAdd{
  position: absolute;
  top:10px;
}

</style>